export default __webpack_public_path__ + "static/media/439.5c7f0a97.png";